import { APICallV3Post } from 'reactApp/api/APICall';
import type { WopiData } from 'reactApp/api/wopi/WopiAPI.types';
import { CloudActions } from 'reactApp/constants/cloudActions';

export class WopiEditAPICall extends APICallV3Post<WopiData> {
    _method = 'wopi-go/edit';
    _headers = { 'X-VFS-Action': CloudActions.FILE_EDIT };
}
